import { SelectInput } from '@/components/form';
import { REGION_OPTIONS } from '@/utils/constant/appConstant';
import { Col, Row } from 'antd';
import React, { useMemo } from 'react';
import { TEAM_OPTIONS } from '../../constants';

interface RegionTeamStepProps {
  selectedRole?: string;
  isRegionAll?: boolean;
  userRegion?: number;
}

export const RegionTeamStep: React.FC<RegionTeamStepProps> = ({
  isRegionAll = true,
  userRegion,
}) => {
  // Filter region options based on user access
  const regionOptions = useMemo(() => {
    if (isRegionAll) {
      return REGION_OPTIONS;
    }
    return REGION_OPTIONS.filter(option => option.value === userRegion);
  }, [isRegionAll, userRegion]);

  return (
    <div>
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Region & Team Assignment</h3>

      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <SelectInput
            name="dogma_region"
            label="Region"
            placeholder="Select region"
            options={regionOptions}
            required

          />
        </Col>

        <Col xs={24} sm={12}>
          <SelectInput
            name="dogma_team"
            label="Team"
            placeholder="Select team"
            options={TEAM_OPTIONS}
          />
        </Col>
      </Row>
    </div>
  );
};

export default RegionTeamStep;
